export class ValidationsLang {
    public CheckInDelaySmallerThanMaximumTimeGapMessage: string;
    public CityValidation: string;
    public DateOfBirthValidation: string;
    public EmailValidation: string;
    public ExpiredDateValidation: string;
    public FirstNameEmptyInputBoxValidation: string;
    public IncorrectHealthCardNumberValidation: string;
    public IncorrectPostalCodeValidation: string;
    public IncorrectZipCodeValidation: string;
    public InvalidLoginValidation: string;
    public LastNameEmptyInputBoxValidation: string;
    public PhoneNumberExtValidation: string;
    public PhoneNumberValidation: string;
    public RegionPostalCodeValidation: string;
    public RegionZipCodeValidation: string;
    public SiteRequiredValidation: string;
    public MultiSiteRequiredValidation: string;
    public StreetAddressValidation: string;
}


// WEBPACK FOOTER //
// ./src/resources/ValidationsLang.ts